const INFO = {
	main: {
		title: "Sean Tsang - Senior Analyst Programmer",
		name: "Sean Tsang",
		email: "seantsangmk@gmail.com",
		logo: "../logo.png",
	},
	socials: {
		github: "https://github.com/seantsangmk",
		linkedin: "https://www.linkedin.com/in/sean-tsang/",
		website: "https://tecky.io/en/media/",
		stackoverflow: "https://stackoverflow.com/users/17681630/seantsang",
	},
	homepage: {
		title: "Automation Engineering for Reliable IT Services",
		description: [
			"Software engineer with 5+ years of IT experience, including an Automation Developer role at Cathay Pacific and current Senior Analyst Programmer work at the SFC.",
			"I have worked with TypeScript, React, Next.js, API integration, OAuth and CAPTCHA; automation testing with Cypress, Jest, and Katalon; and AWS services including Lambda, DynamoDB, and X-Ray.",
			"I hold the ServiceNow Certified System Administrator and AWS Certified Solutions Architect – Associate credentials, and bring a strong focus on secure, reliable technology and continuous learning.",
		],
	},
	about: {
		title: "Cellist, Basketball, Sneakers and Cars",
		description:
		"🏀 🎻 🎵 🚗\nOutside of programming, I’m a cellist who enjoys basketball, sneakers, music, and cars.\n\nI’m currently learning German! 🇩🇪",
	},
	achievements: {
		title: "I am dedicated to continuous learning and personal growth.",
		description:
			"I enjoy learning and growing every day, and I take on challenges with a positive mindset.",
	},
	projects: [
		{
			title: "SFC e-Submission Forms for VASP and OTCD Licensing",
			description:
				"Currently developing new SFC e-submission forms for public applicants seeking new licences, with a primary focus on Virtual Asset Service Providers (VASP) and Over-the-Counter Derivatives (OTCD).",
			logo: [
                 "https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg",
                 "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtoXpzkjeaEr1vPZf-5jy3pyMus27UohQ_nQ&usqp=CAU",
				"https://cdn.worldvectorlogo.com/logos/jenkins-1.svg",
			],
			linkText: "SFC",
			link: "https://wings.sfc.hk/main/#/en/all-forms",
		},
		{
			title: "WebApp SSO with TypeScript, Next.js, API Integration and Security Enhancements",
			description:
				"Revamped the project from scratch using TypeScript with Next.js (ReactJS) for a modern web app. Seamlessly integrated APIs, implemented efficient CAPTCHA handling, i18n, and OAuth for enhanced security.",
			logo: [
				"https://cdn.jsdelivr.net/npm/programming-languages-logos/src/typescript/typescript.png",
				"https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg",
				"https://cdn.worldvectorlogo.com/logos/docker.svg",
				"https://cdn.worldvectorlogo.com/logos/aws-2.svg",
			],
			linkText: "HKTDC",
			link: "https://accounts2.hktdc.com/",
		},
		{
			title: "Automation Test Cases with Katalon, Cypress, and Jest with GitLab CI/CD",
			description:
				"Created comprehensive automation test suites with Katalon, Cypress, and Jest across unit, integration, and end-to-end levels, executed through GitLab pipelines.",
			logo: [
				"https://upload.wikimedia.org/wikipedia/commons/0/00/Katalon-logo-png.png",
				"https://www.cypress.io/images/layouts/cypress-logo.svg",
				"https://cdn.worldvectorlogo.com/logos/gitlab.svg",
			],
		},
		{
			title: "Java Lambda Function for DynamoDB Events",
			description:
				"Created a Java-based serverless Lambda function to effectively manage event handling and querying/inserting items in DynamoDB.",
			logo: [
				"https://cdn.jsdelivr.net/npm/programming-languages-logos/src/java/java.png",
				"https://cdn.worldvectorlogo.com/logos/aws-2.svg",
				"https://cdn.worldvectorlogo.com/logos/amazon-database.svg",
			],
		},
		{
			title: "Python Lambda Function for AWS X-Ray Tracing and Logging to Elasticsearch",
			description:
				"Developed a Python-based serverless lambda function for capturing request information using AWS X-Ray for tracing purposes and logging events to Elasticsearch.",
			logo: [
				"https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
				"https://cdn.worldvectorlogo.com/logos/aws-2.svg",
				"https://cdn.worldvectorlogo.com/logos/elasticsearch.svg",
			],
		},
		{
			title: "Jira, Git, and Confluence for Transparent and Productive Project Execution",
			description:
				"Utilized Scrum, Jira, Git, and Confluence for efficient project management, version control, collaboration, and documentation to ensure transparency and productivity across the organization.",
			logo: [
				"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtoXpzkjeaEr1vPZf-5jy3pyMus27UohQ_nQ&usqp=CAU",
				"https://mhutchie.gallerycdn.vsassets.io/extensions/mhutchie/git-graph/1.30.0/1617594001998/Microsoft.VisualStudio.Services.Icons.Default",
				"https://cdn.iconscout.com/icon/free/png-256/free-confluence-3628704-3029929.png?f=webp",
			],
		},
		// {
		// 	title: "Youthful Website Page using HTML and CSS, MySQL for Data Handling",
		// 	description:
		// 		"Designed and developed a visually appealing website page with a youthful style using HTML and CSS. Implemented MySQL with PHP Laravel to securely store data from online submit forms.",
		// 	logo: [
		// 		"https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
		// 		"https://cdn.jsdelivr.net/npm/programming-languages-logos/src/php/php.png",
		// 		"https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/1024px-HTML5_logo_and_wordmark.svg.png",
		// 	],
		// 	linkText: "HKT-EYE",
		// 	link: "https://www.hkt-eye.com/eyeAIrobot/",
		// },
	],
};
export default INFO;
